var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav-sub-header upper xs-f-small lg-f-xsmall max-at-tweak text-color-2",class:{ 'add-inline-block': !_vm.stretch }},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }